<template>
  <div id="DistributorSearchFilter">
    <h1 class="h1--underline">
      {{ $tv('openDistributor', 'simmerringSelector') }}
    </h1>
    <div class="distributor-search-filter-dropdowns">
      <div>
        <div class="left">
          <label
            :for="'input_searchTerm'"
            class="label"
          >
            {{ $tv('enterLocation', 'distributorSearch') }}
          </label>
          <InputText
            v-model="searchTermString"
            :id="'input_searchTerm'"
            @keyup.enter="sendSearch"
            :placeholder="$tv('placeholderSearch','distributorSearch')"
          />
        </div>
        <div class="right dropDown_classification__wrapper">
          <div class="classification__label">
            <label
              :for="'dropDown_classification'"
              class="label"
            >
              {{ $tv('classification', 'distributorSearch') }}
            </label>
            <a
              href="https://www.fst.com/de/services/logistik-und-supply-chain/haendlernetzwerk/"
              target="_blank"
              class="fill-primary"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1rem"
                width="1rem"
                viewBox="0 -960 960 960"
                class="icon--svg infoIcon fill-primary"
              ><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" /></svg>
            </a>
          </div>
          <DropDown
            :data-items="listOfPartnersMapped"
            @change="handleClassificationSelection"
            :id="'dropDown_classification'"
            :text-field="'text'"
            :data-item-key="'value'"
            :default-item="{text: '', value: ''}"
            :value="selectedClassificationSelection"
          />
        </div>
      </div>
      <div class="distributor-search-submit">
        <kbutton
          :theme-color="'base'"
          @click="removeFilters"
        >
          {{ $tv('resetFilter', 'distributorSearch') }}
        </kbutton>
        <kbutton
          :theme-color="'primary'"
          type="submit"
          @click="sendSearch"
        >
          {{ $tv('search', 'distributorSearch') }}
        </kbutton>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from '~/components/input-components/DropDown'
import InputText from '~/components/input-components/InputText'
import {Button} from '@progress/kendo-vue-buttons'
import {
  DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES,
  DIST_SEARCH_CLASSIFICATION_MAPPING
} from '~/assets/js/constants'

export default {
  components: {
    kbutton: Button,
    InputText,
    DropDown
  },
  data() {
    return {
      selectedClassificationSelection: undefined,
      searchTermString: ''
    }
  },
  computed: {
    listOfPartnersMapped() {
      return [
        {text: this.$tv('sealing', 'classification'), value: DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.sealing},
        {text: this.$tv('aerospace', 'classification'), value: DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.aerospace},
        {text: this.$tv('accumulator', 'classification'), value: DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.accumulator}
      ]
    },
    getFiltersForClassification() {
      switch (this.selectedClassificationSelection?.value) {
      case DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.sealing:
        return DIST_SEARCH_CLASSIFICATION_MAPPING.sealing
      case DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.aerospace:
        return DIST_SEARCH_CLASSIFICATION_MAPPING.aerospace
      case DIST_SEARCH_CLASSIFICATION_DROPDOWN_VALUES.accumulator:
        return DIST_SEARCH_CLASSIFICATION_MAPPING.accumulator
      default: {
        return []
      }
      }
    }
  },
  methods: {
    sendSearch() {
      this.$emit('address', {
        search: this.searchTermString,
        classification: this.getFiltersForClassification
      })
    },
    removeFilters() {
      this.searchTermString = ''
      this.selectedClassificationSelection = null
      this.$emit('reset')
    },
    handleClassificationSelection(data) {
      const classification = data?.value || data?.target?.value
      if (classification) {
        this.selectedClassificationSelection = classification
      } else {
        this.selectedClassificationSelection = null
      }
    }
  }
}

</script>

<style lang="scss">
[id='DistributorSearchFilter'] {
  background-color: $color__content--background__secondary;
  width: 24.75rem;
  padding: $default-margin-padding-width $default-margin-padding-width $default-margin-padding-width $default-margin-padding-2x;
}

.distributor-search-filter-dropdowns {
  display: flex;
  flex-flow: row wrap;
  width: 24.75rem;
  margin-top: 2rem;

  .left {
    margin-right: 1.375rem;
  }

  .right {
    align-items: flex-start;

    .classification__label {
      display: inline-flex;
      align-items: inherit;
    }
  }

  @include breakpoint-up($md) {
    .dropDown_classification__wrapper {
      max-width: 11.5rem;
    }
  }

  .label {
    margin-bottom: .5rem;
    display: block;
    width: 100%;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: $default-margin-padding-2x;
    width: 100%;

    > div {
      width: 50%;
    }

    &:nth-child(2) {
      margin-bottom: 0;
    }
  }

  .k-dropdown,
  .k-dropdowntree {
    width: 100%;
  }

  .k-input,
  .k-textbox,
  .drop-down,
  .k-combobox {
    width: 100%;
    border-color: $color__input__border;
    border-width: .0612rem;
    border-radius: 0;
  }

  .distributor-search-submit {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
}

@include breakpoint-down($md) {
  [id='DistributorSearchFilter'] {
    padding: $default-margin-padding-width;
  }

  .distributor-search-filter-dropdowns {
    justify-content: center;
    width: 100%;

    > div {
      flex-direction: column;

      > div,
      .k-dropdown {
        width: 100%;
      }
    }

    .right {
      margin-top: $default-margin-padding-width;
    }
  }
}

</style>
